// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"e787f1b5","231":"b1dc0c2e","289":"963c5b0d","331":"cca939ab"}[chunkId] + ".chunk.js";
};